import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import {
  lengthValidation120,
  required,
  validateHttpsUrl,
  validateUrl,
} from '../../Forms/utils';

import { REACT_SELECT_INPUT, STYLED_TEXT } from '../../Forms/fieldTypes';

const ExternalLinksFormComponent = (props) => {
  const { t } = useTransl();
  const {
    accountId,
    form,
    initialValues,
    onSubmit,
    onLoad,
    onUnmount,
    buildings,
  } = props;
  const formData = [
    {
      keyName: 'name',
      label: t('title.internalName'),
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation120],
    },
    {
      keyName: 'displayName',
      label: t('title.displayName'),
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation120],
    },
    {
      keyName: 'url',
      label: t('title.url'),
      fieldType: STYLED_TEXT,
      validate: [required, validateUrl, validateHttpsUrl],
    },
    {
      keyName: 'availableBuildings',
      label: t('title.availableFor'),
      fieldType: REACT_SELECT_INPUT,
      options: buildings,
      multi: true,
      validate: [],
    },
  ];

  const title = `${accountId ? t('actions.update') : t('actions.create')} ${t(
    'account.customLinks',
  )}`;

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      initialValues={initialValues}
      onSubmit={onSubmit}
      onLoad={onLoad}
      onUnmount={onUnmount}
      title={title}
      enableReinitialize
    />
  );
};

ExternalLinksFormComponent.defaultProps = {
  accountId: null,
};

ExternalLinksFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired,
  onUnmount: PropTypes.func.isRequired,
  accountId: PropTypes.string,
  buildings: PropTypes.instanceOf(Object),
};

export default ExternalLinksFormComponent;
